import { ExpandableCard } from '@shared';

export interface TableExpandableCards {
	tableName: string;
	expandableCards: ExpandableCard[];
}
